<button 
    type="button" 
    class="btn" 
    [ngClass]="btnClass" 
    (click)="showWindow()" 
    paftooltip="Afficher_historique">
    <i class="fas fa-tasks"></i>
</button>
